import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';

const GeneralTabIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M17.5 1H3.5C2.39543 1 1.5 1.89543 1.5 3V17C1.5 18.1046 2.39543 19 3.5 19H17.5C18.6046 19 19.5 18.1046 19.5 17V3C19.5 1.89543 18.6046 1 17.5 1Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.5 1V9L12.5 6L15.5 9V1'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};

export default memo(GeneralTabIcon);
